import { Ellipsis } from '@seiue/ui'
import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'

/**
 * 任务头部左侧组件
 *
 * @param param0 - 参数
 * @param param0.title - 标题
 * @param param0.onClose - 关闭回调
 * @returns 组件
 */
export const TaskHeaderLeft: FC<{ title: string; onClose?: () => void }> = ({
  title,
  onClose,
}) => {
  const history = useHistory()
  const onCloseFallback = () => {
    history.push(`/`)
  }
  return (
    <Header>
      <IconWrapper onClick={onClose ?? onCloseFallback}>
        <GrowpIcon
          name="Right"
          size={20}
        />
      </IconWrapper>
      <LayoutHeaderTitle text={title} />
    </Header>
  )
}

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const IconWrapper = styled.div`
  cursor: pointer;
  margin-right: 12px;
`

const LayoutHeaderTitle = styled(Ellipsis)`
  font-size: 20px;
  line-height: 32px;
  width: 60vw;
  font-weight: normal;
  color: ${(p) => p.theme.text._1};
`
